type DownloadUpgradePromptSurface = 'download_toast' | 'asset_modal' | 'subvariant_download'

type DownloadUpgradePromptEvent = 'download_upgrade_prompt_shown' | 'download_upgrade_prompt_clicked'

type DownloadUpgradePromptPayload = {
  surface: DownloadUpgradePromptSurface
  is_logged_in: boolean
  refusal_code?: string
}

/** Sends upgrade-prompt events through the shared analytics client. */
export function sendDownloadUpgradePromptEvent(
  event: DownloadUpgradePromptEvent,
  payload: DownloadUpgradePromptPayload
) {
  if (typeof window === 'undefined') {
    return
  }

  const send = window.getGlobalSession?.()?.analytics?.sendCustomEvent

  if (typeof send !== 'function') {
    return
  }

  try {
    send(event, payload)
  } catch (error) {
    console.debug('download-upgrade analytics event failed', { event, payload, error })
  }
}
